module.exports = __webpack_public_path__ + "img/17ne.d9b8c715.svg";